/**
 * The different tasks (SLI) we track for our SLOs. Each task may have success, error or performance
 * measurements associated with it.
 */
export const SLOTask = Object.freeze({
  ViewAppsList: 'view-apps-list'
});
export const LABEL_CAAS_SPI_METHOD_EXECUTION = 'caas-spi-execution';